import React from "react";
import { Link } from "react-router-dom";
import { Utensils, Flower, Heart, BedDouble, Sunset, Bike, Wine, Gift, Sparkles, Flame } from "lucide-react";
import { tr } from "../../lib/i18n";

export const GIFT_ICONS = { utensils: Utensils, flower: Flower, heart: Heart, bed: BedDouble, sunset: Sunset, bike: Bike, wine: Wine, gift: Gift, sparkles: Sparkles, flame: Flame };
export const eur = (cents) => `€ ${(Number(cents || 0) / 100).toLocaleString("it-IT", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
export const mediaSrc = (u) => (!u ? "" : u.startsWith("/api/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);

export const GT = {
  regala: { it: "Regala", en: "Gift", es: "Regala", fr: "Offrir", de: "Schenken" },
  regalaQuesta: { it: "Regala questa esperienza", en: "Gift this experience", es: "Regala esta experiencia", fr: "Offrez cette expérience", de: "Diese Erfahrung schenken" },
  perPersona: { it: "a persona", en: "per person", es: "por persona", fr: "par personne", de: "pro Person" },
  aCamera: { it: "a camera", en: "per room", es: "por habitación", fr: "par chambre", de: "pro Zimmer" },
  persone: { it: "persone", en: "guests", es: "personas", fr: "personnes", de: "Personen" },
  per: { it: "Per", en: "For", es: "Para", fr: "Pour", de: "Für" },
  da: { it: "da", en: "from", es: "de", fr: "de", de: "von" },
  validoFino: { it: "Valido fino al", en: "Valid until", es: "Válido hasta", fr: "Valable jusqu'au", de: "Gültig bis" },
  ilPercorso: { it: "Il percorso", en: "The journey", es: "El recorrido", fr: "Le parcours", de: "Die Reise" },
};

export function MediaBg({ url, poster, className = "" }) {
  const src = mediaSrc(url);
  const isVideo = /\.(mp4|webm|mov)(\?|$)/i.test(src);
  if (!src && !poster) return <div className={`absolute inset-0 bg-[#4a1c17] ${className}`} style={{ backgroundImage: "radial-gradient(rgba(255,220,180,0.18) 1px, transparent 1px)", backgroundSize: "12px 12px" }} />;
  if (isVideo) return <video className={`absolute inset-0 w-full h-full object-cover ${className}`} src={src} poster={mediaSrc(poster)} autoPlay loop muted playsInline preload="metadata" aria-hidden="true" />;
  return <img className={`absolute inset-0 w-full h-full object-cover ${className}`} src={src || mediaSrc(poster)} alt="" aria-hidden="true" />;
}

export function GiftPill({ element, lang = "it" }) {
  return (
    <Link to={`/regala${element ? `?add=${element}` : ""}`} data-testid="gift-pill"
      className="group flex items-center justify-between gap-3 rounded-2xl border border-[#C48B31]/40 bg-gradient-to-r from-[#fff8ec] to-white px-4 py-3 shadow-sm hover:shadow-md hover:border-[#C48B31] transition-all">
      <span className="flex items-center gap-3">
        <span className="h-9 w-9 rounded-full bg-[#C48B31] text-white flex items-center justify-center shadow"><Gift className="h-4 w-4" /></span>
        <span className="text-left leading-tight">
          <span className="block font-serif text-base font-bold text-[#2b1410]">{tr(GT.regalaQuesta, lang)}</span>
          <span className="block text-[11px] text-[#7c5a4e]">{tr({ it: "Voucher digitale · configuralo in 3 tocchi", en: "Digital voucher · build it in 3 taps", es: "Voucher digital · en 3 toques", fr: "Bon digital · en 3 touches", de: "Digitaler Gutschein · in 3 Schritten" }, lang)}</span>
        </span>
      </span>
      <span className="text-[#C48B31] group-hover:translate-x-0.5 transition-transform">→</span>
    </Link>
  );
}
